import type { VoidFunctionComponent } from 'react';
import DrawerSection from './Section';
import DetailsPanel, { DetailsPanelList } from '../../../generic/DetailsPanel';
import styles from './VulnerabilitiesDrawer.module.less';
import type { CVSSMetric } from '../../../../../shared/vulns/types';

type Props = {
  isLoading?: boolean;
  metrics: CVSSMetric[];
};

/**
 * VulnerabilityDrawerNVDBaseMetrics displays the CVSS
 * attribute breakdown of this vulnerability (if available).
 */
const VulnerabilityDrawerNVDBaseMetrics: VoidFunctionComponent<Props> = ({
  isLoading,
  metrics,
}) => (
  <DrawerSection>
    <DetailsPanel
      id="package-vulns-drawer-nvd-base-metrics"
      target="NVD base metrics"
      isLoading={isLoading}
    >
      {metrics.length === 0 ? (
        <div className={styles.emptySectionText}>NVD metrics are unavailable for this vulnerability</div>
      ) : (
        <DetailsPanelList
          rows={metrics.map(metric => ({
            label: metric.name,
            content: metric.value,
          }))}
        />
      )}
    </DetailsPanel>
  </DrawerSection>
);

export default VulnerabilityDrawerNVDBaseMetrics;
